var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.293,
    height: 187.132,
    viewBox: "0 0 51.142 49.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "J",
    d: "M339.237-33.772h408.177v294.351H339.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m352.744 129.509-20.105-29.486h-27.224l12.562 29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m305.415 100.023 12.562 29.486h-62.131l12.562-29.486z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m286.911 227.49-31.065-97.981h62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M332.639 100.023h-27.224l12.562 29.486h34.767z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M317.977 129.509h-62.131l12.562-29.486h37.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M255.846 129.509h62.131l-31.066 97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M317.977 129.509h34.767l-20.105-29.486h-27.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M268.408 100.023h37.007l12.562 29.486h-62.131z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m317.977 129.509-31.066 97.981-31.065-97.981z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M97.761 372.257c13.443 14.542 80.258 10.062 93.346 0s11.141-85.514 0-93.346-84.422-10.972-93.346 0c-8.925 10.973-13.443 78.804 0 93.346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "m596.527 242.69-25.634-80.849h-28.687z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "m622.16 161.841-25.633 80.849-25.634-80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "m596.527 80.859 25.633 80.849h28.688z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "n",
    d: "m570.893 161.708 25.634-80.849 25.633 80.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M253.01 353.699v-28.433l34.629-42.986 18.091 52.979-11.465 37.397-24.638 18.014z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 45,
      lineHeight: "100%",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#005b00",
      fillOpacity: 1,
      stroke: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-63.024 237.13q2.68-3.8 4.12-7.2.72-1.68.72-2.2 0-.48-.44-.48-.32 0-.72.16-2.96 1.24-4.08 1.24-.88 0-2.12-.64-1.24 1.88-3.44 4.32 1.04 1 3.56 1.56 1 .2 1.6 1 .84 1.12.84 1.88 0 .12-.04.36m-1.8-10.2q.48.08.8.08 1.12 0 3.12-.64 1.28-.4 2.72-1.28.64-.4 1.04-.4.64 0 2.32 1.24 1 .72 1 1.2 0 .36-.72.92-.36.28-.6.64-.28.36-1.12 2.12-4.48 9.52-13.96 16.12-1.64 1.12-3.92 2.4-.2.12-.32.12-.44 0-.44-.44 0-.2.12-.32.16-.12 2.48-1.88 5.52-4.44 8.84-9.12-.28.16-.48.16-1 0-2.72-1.52-1.48-1.28-2.88-3.36-2.6 2.56-4.28 3.76-.8.56-1 .56-.4 0-.4-.36 0-.24 1.84-2.12 2.52-2.52 5.04-6.84 1.24-2.12 1.24-3.16 0-.64-.36-1.2t-.36-.92q0-.84.88-.84 1.08 0 2.76 1.32.92.72.92 1.28 0 .24-.32.56-.48.56-1.24 1.92",
    style: {
      fontSize: 40,
      fontFamily: "TPKaisho-GT01",
      InkscapeFontSpecification: "TPKaisho-GT01",
      textAlign: "center",
      textAnchor: "middle",
      fill: "#005b00",
      fillOpacity: 1
    },
    transform: "matrix(1.64667 0 0 1.79439 130.871 -397.86)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.9130440df73623739f494dfe6ebe4c1b.svg";
export { ForwardRef as ReactComponent };